<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('souvenirPhotos')" />
    <div class="sf-container">
      <v-card class="sf-card"
              flat
              v-if="filteredPhotos.length === 0">
        <v-card-text class="sf-card__body text-center sf-muted">
          Leider hatten wir keine Gelegenheit Erinnerungsfotos von Ihrem Messeauftritt zu erstellen. Vielleicht beim nächsten Mal!
        </v-card-text>
      </v-card>
      <template v-else>
        <v-card class="sf-card sf-photos__main"
                flat>
          <v-img class="sf-photos__image"
                 v-bind:aspect-ratio="4/3"
                 v-bind:src="`/images/temp/${selectedPhoto.imageName}.jpg`"
                 v-bind:lazy-src="`/images/temp/small/${selectedPhoto.imageName}.jpg`" />
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary"
                   depressed
                   v-bind:href="`/images/temp/${selectedPhoto.imageName}.jpg`"
                   download>
              <v-icon left>ti-download</v-icon>
              {{ $t('download') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-row class="mt-2">
          <v-col cols="6" sm="4" md="2" v-for="(photo, index) in filteredPhotos" v-bind:key="`thumbnail-${index}`">
            <v-card class="sf-card sf-card--interactive sf-photos__thumb"
                    flat
                    v-bind:class="{ 'sf-photos__thumb--active': index === selectedPhotoIndex }"
                    v-on:click="selectedPhotoIndex = index">
              <v-img class="sf-photos__thumb-image"
                     v-bind:aspect-ratio="4/3"
                     v-bind:src="`/images/temp/small/${photo.imageName}.jpg`" />
            </v-card>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
  import imageMapping from '@/temp-image-mapping.json'

  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      TopHeader
    },
    computed: {
      filteredPhotos() {
        return imageMapping.filter(photo => photo.supplierId == this.supplierId)
      },
      selectedPhoto() {
        return this.filteredPhotos[this.selectedPhotoIndex]
      }
    },
    created() {
      this.supplierId = this.$route.params.supplierId
    },
    data: () => ({
      supplierId: null,
      selectedPhotoIndex: 0
    }),
    name: 'SouvenirPhotos'
  }
</script>

<style scoped>
  .sf-photos__image {
    border-radius: 16px 16px 0 0;
  }

  .sf-photos__thumb {
    overflow: hidden;
  }

  .sf-photos__thumb--active {
    border-color: var(--sf-primary) !important;
    box-shadow: 0 0 0 2px var(--sf-primary) !important;
  }
</style>

<i18n>
  {
    "de": {
      "download": "Herunterladen",
      "souvenirPhotos": "Erinnerungsfotos"
    },
    "en": {
      "download": "Download",
      "souvenirPhotos": "Souvenir photos"
    }
  }
</i18n>